module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/MaterialIcons-Regular.woff2
// module id = 21
// module chunks = 0